export const rtlLanguageList = ['AR', 'FA', 'KD', 'PS', 'KU'];
